import netflix from "../Assets/otts/netflix.jpg";
import jiohotstar from "../Assets/otts/jiohotstar.jpg";
import aha from "../Assets/otts/aha.png";
import zee5 from "../Assets/otts/zee5.jpg";
import sunnxt from "../Assets/otts/sunnxt.jpg";
import altbalaji from "../Assets/otts/altbalaji.jpg";
import hungama from "../Assets/otts/hungama.png";
import etv from "../Assets/otts/etv.png";
import amazonprime from "../Assets/otts/amazonprime.jpg";

export const LOCAL_OTT_LOGOS = {
    netflix,
    jiohotstar,
    aha,
    zee5,
    sunnxt,
    altbalaji,
    hungama,
    etv,
    amazonprime
};

export const getOttLogoUrl = (logo) => {
    if (!logo) return "";
    const lower = logo.toLowerCase();
    for (const key in LOCAL_OTT_LOGOS) {
        if (lower === key || lower.includes(key)) {
            return LOCAL_OTT_LOGOS[key];
        }
    }
    return logo; // Fallback to URL
};

export const ALL_OTTS = [
    { id: "jiohotstar", name: "JioHotstar", logo: jiohotstar, color: "#002b66" },
    { id: "netflix", name: "Netflix", logo: netflix, color: "#e50914" },
    { id: "aha", name: "Aha", logo: aha, color: "#ff6b00" },
    { id: "zee5", name: "Zee5", logo: zee5, color: "#8230c6" },
    { id: "sunnxt", name: "SunNXT", logo: sunnxt, color: "#f37023" },
    { id: "altbalaji", name: "AltBalaji", logo: altbalaji, color: "#111111" },
    { id: "hungama", name: "Hungama", logo: hungama, color: "#00a9e0" },
    { id: "etv", name: "ETV Win", logo: etv, color: "#e31e24" },
    { id: "amazonprime", name: "Amazon Prime", logo: amazonprime, color: "#00a8e1" },
];

export const DEFAULT_PLAN_OTTS = {
    "40": ["jiohotstar", "aha"],
    "50": ["jiohotstar", "aha", "zee5"],
    "75": ["netflix", "jiohotstar", "aha", "zee5", "sunnxt"],
    "100": ["netflix", "jiohotstar", "amazonprime", "zee5", "aha", "sunnxt", "etv", "hungama", "altbalaji"],
};

const STORAGE_KEY = "ritu_broadband_plan_otts";

export const getPlanOttConfig = () => {
    try {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved) {
            return JSON.parse(saved);
        }
    } catch (e) {
        console.error("Error reading OTT config from localStorage", e);
    }
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(DEFAULT_PLAN_OTTS));
    } catch (e) { }
    return { ...DEFAULT_PLAN_OTTS };
};

export const savePlanOttConfig = (config) => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
        window.dispatchEvent(new CustomEvent("ottConfigUpdated", { detail: config }));
    } catch (e) {
        console.error("Error saving OTT config to localStorage", e);
    }
};

export const getOttsForPlanSpeed = (speed, duration = null, config = null) => {
    const currentConfig = config || getPlanOttConfig();
    let ottIds = [];
    if (duration !== null && duration !== undefined) {
        const durationKey = `${speed}_${duration}`;
        if (currentConfig[durationKey]) {
            ottIds = currentConfig[durationKey];
        } else {
            ottIds = currentConfig[speed] || [];
        }
    } else {
        ottIds = currentConfig[speed] || [];
    }
    return ALL_OTTS.filter((ott) => ottIds.includes(ott.id));
};
